import React, { useState } from 'react';
import axios from "axios";
import './w3.css';
import './style.css';
import img1 from './images/img1.jpg';
import avlogo from './images/avlogo.png';
import poc from './images/POC.png';
import box1 from './images/PNG/box_img1.jpg';
import box2 from './images/PNG/box_img2.jpg';
import box3 from './images/PNG/box_img3.jpg';
import box4 from './images/PNG/_DSC9674.png';
import box5 from './images/PNG/box_img4.jpg';
import box6 from './images/PNG/_DSC9679.png';
import box7 from './images/PNG/_DSC9680.png';
import box8 from './images/PNG/_DSC9684.png';



window.onscroll = function(){
  myFunction();
}

function myFunction(){
 
}



const jumpToReleventDiv = (id: string) => {
  //const releventDiv = document.getElementById(id);
  // behavior: "smooth" parameter for smooth movement
  //releventDiv.scrollIntoView({behavior: "smooth"});

  document.querySelector(`#${id}`)?.scrollIntoView({behavior: "smooth"})
}



function Home() {
 
  const [ishide, setHide] = useState(true);

  const openModal = () => { 
    setHide(false);
  } 

  const closeModal = () => {
    setHide(true);
  }

    const [formData, setFormData] = useState({
        name: '',
        mobile: '',
        email: '',
        address: '',
        city: '',
        state: '',
        pin: ''
     });

     const [errors, setErrors] = useState({
       name: '',
        mobile: '',
        email: '',
        address: '',
        city: '',
        state: '',
        pin: ''
     });

     const handleChange = (e: { target: { name: any; value: any; }; }) => {
      const { name, value } = e.target;
      setFormData({
          ...formData,
          [name]: value,
      });
  };

  const handleSubmit = (e:any) => {
    e.preventDefault();
    const newErrors = validateForm(formData);
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
        // Form submission logic here
        var data = 'name='+formData.name+'&mobile='+formData.mobile+'&email='+formData.email+'&address='+formData.address+'&city='+formData.city+'&state='+formData.state+'&pin='+formData.pin ;
       axios.get('https://aranyakvalley.com/api/pocbox.php?'+data).then((res:any)=>{
       // console.log(res['data'].success);
          if(res['data'].success == true){
              alert(res['data'].msg);
          }else{
            alert('Please try again later');
          }
          closeModal();
       })
      //  console.log('Form submitted successfully!');
    } else {
        console.log('Form submission failed due to validation errors.');
    }
};


  const validateForm = (data:any) => {
    const errors:any = {};

    if (!data.name.trim()) {
        errors.name = 'Full Name is required';
    } 

    if (!data.email.trim()) {
        errors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(data.email)) {
        errors.email = 'Email is invalid';
    }

    if(!data.mobile.trim()){
      errors.mobile = "Mobile number is required";
    }else if(data.mobile.length > 10 || data.mobile.length < 10){
      errors.mobile = "Mobile number must be of 10 digits";
    }

    if(!data.address.trim()){
      errors.address = "Address is required";
    }
    if(!data.city.trim()){
      errors.city = "City is required";
    }
    if(!data.state.trim()){
      errors.state = "State is required";
    }
    if(!data.pin.trim()){
      errors.pin = "Pin code is required";
    }else if(data.pin.length > 6 || data.pin.length < 6){
      errors.pin = "Pin code must be of 6 digits";
    }

    

    return errors;
};

  

  return (
    <div className='Home'>

      <div className="w3-top">
        <div className="w3-bar w3-white" id="myNavbar">
          
          <a href="#" className="w3-bar-item w3-button">
            <img src={poc} width={60} height={20}/>
          </a>
          <a href="javascript:void(0);" className="w3-bar-item w3-button w3-hide-small" onClick={()=>jumpToReleventDiv("about")}><i className="fa fa-user" /> ABOUT</a>
          <a href="javascript:void(0);" className="w3-bar-item w3-button w3-hide-small" onClick={()=>jumpToReleventDiv("portfolio")}><i className="fa fa-th" /> SOUVENIR BOX</a>
          <a href="javascript:void(0);" className="w3-bar-item w3-button w3-hide-small" onClick={()=>jumpToReleventDiv("contact")}><i className="fa fa-envelope" /> CONTACT</a>
          
        </div>
      </div>


    

    <div className="bgimg-1 w3-display-container w3-opacity-min" id="home">
        <div className="w3-display-middle" style={{whiteSpace: 'nowrap'}}>
          <span className="w3-center w3-padding-large w3-black w3-xlarge w3-wide w3-animate-opacity">Pride of Cachar souvenir box</span>
          <div className="w3-center" style={{marginTop: '10px'}}>
          <button onClick={openModal} className='w3-button w3-padding-large w3-light-grey'>ORDER NOW</button>
          </div>
        </div>
        
       
       
       
    </div>

      <div className="w3-content w3-container w3-padding-64" id="about">
        <h3 className="w3-center">ABOUT CACHAR</h3>
        <p>The District of Cachar, one of Assam’s oldest districts, is situated in the southernmost part of the State, bordered by the picturesque Barail, Jaintia and Lushai hills. The word “Cachar” (Kachar/ Xasaar in local laguage) translates to “land at the foot of a mountain”, signifying its geographical charm. </p>
        <p>The district was created in 1830, following the annexation of the Kachari Kingdom by the British. In 1854, North Cachar was annexed and tagged to the district. </p>
        <p>Thus, the erstwhile Cachar included entire Barak Valley and North Cachar Hills (Haflong) of today. Later between 1951 and 1989, three additional districts were carved out of it for the ease of administration. </p>
        <p>Despite these changes, the spirit of erstwhile Cachar is palpable in the entire valley of Barak and the hills of Haflong, as the cultural life remains closely intertwined.</p>
        <div className="w3-row">
          <div className="w3-col m6 w3-center w3-padding-large">
            <p><b>What is Aranyak Valley</b></p><br />
            <img src={avlogo} className="w3-round w3-image w3-opacity w3-hover-opacity-off" alt="Photo of Me" width={350} height={350} />
          </div>
          {/* Hide this text on small devices */}
          <div className="w3-col m6  w3-padding-large">
            <p>Aranyak® Valley is a social startup working to create awareness on Native Ecology, Heritage and Pride in the Tier 4 regions (like Cachar/ Barak Valley) and it’s micro-communities. We do this through Building Pride Habitats® that are hyperlocal skilling and native ecology reinstatement institutions. We train our students to do well in their life while staying fully “rooted”.</p>
            <p>
            Aranyak’s hyperlocal Pride Habitats have three Elements: Education, Ecology and Experience. Since inception we have trained over 3,500 students who have in turn helped us create a sprawling repository of over 12,500 native trees and plants within our habitats, while ensuring zero usage of chemical fertilizers and pesticides.
            </p>
            <p>To learn more about us click here <a href='https://aranyakvalley.com/#/whoarewe' target='blank'>learn more</a></p>
            <p>Want to Join us click here <a href='https://aranyakvalley.com/#/getinvolved' target='blank'>join us</a></p>
          </div>
        </div>
        <p className="w3-large w3-center w3-padding-16">We are really good at:</p>
        <p className="w3-wide"><i className="fa fa-pencil-square" />Education</p>
        <div className="w3-light-grey">
          <div className="w3-container w3-padding-small w3-dark-grey w3-center" style={{width: '85%'}}>85%</div>
        </div>
        <p className="w3-wide"><i className="fa fa-tree" />Ecology</p>
        <div className="w3-light-grey">
          <div className="w3-container w3-padding-small w3-dark-grey w3-center" style={{width: '85%'}}>85%</div>
        </div>
        <p className="w3-wide"><i className="fa fa-line-chart" />Experience</p>
        <div className="w3-light-grey">
          <div className="w3-container w3-padding-small w3-dark-grey w3-center" style={{width: '90%'}}>90%</div>
        </div>
      </div>

      <div className="w3-row w3-center w3-dark-grey w3-padding-16">
          <div className="w3-third w3-section">
            <span className="w3-xlarge">3500+</span><br />
            Trained Students
          </div>
          <div className="w3-third w3-section">
            <span className="w3-xlarge">12,500+</span><br />
            Native trees
          </div>
          <div className="w3-third w3-section">
            <span className="w3-xlarge">0%</span><br />
            Usage of chemical

          </div>

        </div>

    <div className="bgimg-2 w3-display-container w3-opacity-min">
      <div className="w3-display-middle w3-center">
        <span className="w3-xxlarge w3-text-white w3-wide">THE PRIDE OF CACHAR SOUVENIR BOX</span>
      </div>
    </div>

    
    <div className="w3-content w3-container w3-padding-64" id="portfolio">
      <p className='w3-center'>
      “Pride of Cachar®” campaign by Aranyak® Valley aims to capture the spirit of everything about 
yesteryear’s Cachar.

      </p>
      
      <p className="w3-center"><em>Through this “Pride of Cachar®” box, you have a slice of our Ecology element in your hands. Our Ecology products aim to move beyond agriculture that ‘does no harm’, to an integrated approach that boosts local agri produce concurrently with other benefits such as soil and water quality, biological conservation of native species of trees and herbs, and increased resilience of rural communities.</em></p>
      <p className="w3-center"><em>This Pride of Cachar souvenir box is a celebration of diverse but shared ecology, heritage and craftsmanship of Barak Valley region of Assam. Each of the three unique tea blends, is handcrafted to perfection by skilled workers of Aranyak Valley. The organically grown tea reflects the purity of nature, while every sip embodies love, pride, and the spirit of our rural communities.</em></p>
      <br/>
     <div className="w3-row-padding w3-center">
        <div className="w3-col m3">
          <img src={box4} style={{width: '100%'}} className="w3-hover-opacity" alt="The mist over the mountains" />
        </div>
        <div className="w3-col m3">
          <img src={box6} style={{width: '100%'}} className="w3-hover-opacity" alt="Coffee beans" />
        </div>
        <div className="w3-col m3">
          <img src={box7} style={{width: '100%'}} className="w3-hover-opacity" alt="Bear closeup" />
        </div>
        <div className="w3-col m3">
          <img src={box8} style={{width: '100%'}} className="w3-hover-opacity" alt="Quiet ocean" />
        </div>
      </div>
      <div className="w3-row-padding w3-center">
        <div className="w3-col m3">
          <img src={box1} style={{width: '100%'}} className="w3-hover-opacity" alt="The mist over the mountains" />
        </div>
        <div className="w3-col m3">
          <img src={box2} style={{width: '100%'}} className="w3-hover-opacity" alt="Coffee beans" />
        </div>
        <div className="w3-col m3">
          <img src={box3} style={{width: '100%'}} className="w3-hover-opacity" alt="Bear closeup" />
        </div>
        <div className="w3-col m3">
          <img src={box5} style={{width: '100%'}} className="w3-hover-opacity" alt="Quiet ocean" />
        </div>
        <button onClick={openModal}  className="w3-button w3-padding-large w3-light-grey" style={{marginTop: 64}}>ORDER NOW</button>

      </div>

    </div>

    <div className="bgimg-3 w3-display-container w3-opacity-min">
      <div className="w3-display-middle">
        <span className="w3-xxlarge w3-text-white w3-wide">CONTACT US</span>
      </div>
    </div>

    
  <div className="w3-content w3-container w3-padding-64" id="contact">
  <h3 className="w3-center">WHERE WE WORK</h3>
  <p className="w3-center"><em>We'd love your feedback!</em></p>
  <div className="w3-row w3-padding-32 w3-section">
    <div className="w3-col m4 w3-container">
      <img src={poc} className="w3-image w3-round" style={{width: '100%'}} />
    </div>
    <div className="w3-col m8 w3-panel">
      <div className="w3-large w3-margin-bottom">
        <i className="fa fa-map-marker fa-fw w3-hover-text-black w3-xlarge w3-margin-right" /> 1st Floor Shashadhar Villa, Behind ICICI Bank, Nag Naha Lane,
        Shillongpatty, Silchar, Assam, India.<br />
        <i className="fa fa-phone fa-fw w3-hover-text-black w3-xlarge w3-margin-right" />  (IN) 03842 224 224 +91 9706 538 587<br />
        <i className="fa fa-envelope fa-fw w3-hover-text-black w3-xlarge w3-margin-right" /> Email: farm.enquiry@aranyakvalley.com<br />
      </div>
      
    </div>
  </div>
</div>

<footer className="w3-center w3-black w3-padding-64 w3-opacity w3-hover-opacity-off">
  <a href="#" className="w3-button w3-light-grey"><i className="fa fa-arrow-up w3-margin-right" />To the top</a>
  <div className="w3-xlarge w3-section">
    <a href='https://www.facebook.com/PrideOfCachar' target='blank'><i className="fa fa-facebook-official w3-hover-opacity" /></a>
    <a href='https://www.instagram.com/prideofcachar?igsh=MWw1azg1dDE0ZGRpaQ==' target='blank'><i style={{marginLeft: 5}} className="fa fa-instagram w3-hover-opacity" /></a>
  </div>
  <p>Powered by <a href="https://aranyakvalley.com/" title="W3.CSS" target="_blank" className="w3-hover-text-green">Aranyak Valley</a></p>
</footer>


<div id="id01" className="w3-modal w3-animate-opacity" style={{
    display: ishide ? 'none' : 'block'
}}>
      <form className="w3-container" onSubmit={handleSubmit} >
          <div className="w3-modal-content w3-card-4" style={{maxWidth: '600px'}}>
            <header className="w3-container w3-teal"> 
              <span onClick={closeModal}  className="w3-button w3-large w3-display-topright">×</span>
              <h2 style={{color: '#fff'}}>ORDER SOUVENIR BOX</h2>
            </header>
            <div className="w3-container">
            <div className="w3-section">
                <div>
                  <label><b>Full Name</b></label>
                  <input className="w3-input w3-border" type="text" placeholder="Enter Full Name" name="name"  
                  value={formData.name}
                  onChange={handleChange} />
                  {errors.pin && (
                    <span className="error-message">
                        {errors.name}
                    </span>
                  )}
                </div>
                <div>
                  <label><b>Mobile Number (Whatsapp number recommended)</b></label>
                  <input className="w3-input w3-border" type="number"  placeholder="Enter Mobile" name="mobile" 
                  value={formData.mobile}
                  onChange={handleChange} />
                  {errors.pin && (
                    <span className="error-message">
                        {errors.mobile}
                    </span>
                  )}
                </div>
                <div>
                  <label><b>Email Address</b></label>
                  <input className="w3-input w3-border" type="email"  placeholder="Enter Email" name="email"  
                  value={formData.email}
                  onChange={handleChange}/>
                  {errors.pin && (
                    <span className="error-message">
                        {errors.email}
                    </span>
                  )}
                </div>
                <div>
                    <label><b>Communication Address</b></label>
                    <textarea name="address" id="address" className="w3-input w3-border" cols={3} 
                    value={formData.address}
                    onChange={handleChange}></textarea>
                    {errors.pin && (
                      <span className="error-message">
                          {errors.address}
                      </span>
                    )}
                </div>
                <div>
                  <label><b>City</b></label>
                  <input className="w3-input w3-border" type="text"  placeholder="Enter City" name="city" 
                  value={formData.city}
                  onChange={handleChange} />
                  {errors.pin && (
                    <span className="error-message">
                        {errors.city}
                    </span>
                  )}
                </div>
                <div>
                  <label><b>State</b></label>
                  <input className="w3-input w3-border" type="text"placeholder="Enter State" name="state" 
                  value={formData.state}
                  onChange={handleChange} />
                  {errors.pin && (
                    <span className="error-message">
                        {errors.state}
                    </span>
                  )}
                </div>
                <div>
                  <label><b>Pin Code</b></label>
                  <input className="w3-input w3-border" type="number"  placeholder="Enter Pin code" name="pin" 
                  value={formData.pin}
                  onChange={handleChange} />
                  {errors.pin && (
                    <span className="error-message">
                        {errors.pin}
                    </span>
                  )}
                </div>

            </div>

            </div>
            <footer className="w3-container w3-teal" style={{padding: 5}}>
            <button  type="submit" className="w3-button w3-green">Place Order</button>
            <button onClick={closeModal} type="button" className="w3-button w3-red" style={{marginLeft: 3}}>Cancel</button>
            </footer>
          </div>
      </form>
</div>






    </div>
  )
}

export default Home